var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../..';
import { IconName, IconSize } from '../../Atoms/Icon/Icon.enum';
import { handleTooltipArrowPosition, handleTooltipPosition } from './Tooltip.helpers';
const BaseTooltip = styled.div `
  position: relative;
  display: inline-block;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;
const IconWrapper = styled.div `
  padding: 16px;
  margin: -16px;
`;
const BaseTooltipContent = styled.div `
  position: absolute;
  display: inline-flex;
  width: max-content;
  min-height: max-content;
  border-radius: 4px;
  ${({ direction }) => handleTooltipPosition(direction)}
  box-shadow: ${({ theme }) => theme.shadows.medium};
  z-index: 1;

  &:before {
    content: '';
    width: 11px;
    height: 11px;
    position: absolute;
    background-color: ${({ theme }) => theme.colors.ui01};
    transform: translateX(-50%) rotate(45deg);
    ${({ direction }) => handleTooltipArrowPosition(direction)}
    box-shadow: ${({ theme }) => theme.shadows.medium};
  }
`;
const BaseTooltipWrapper = styled.div `
  display: inline-flex;
  padding: 8px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.ui01};
  z-index: 1;
`;
const Tooltip = (_a) => {
    var { children, icon, direction, className } = _a, delegated = __rest(_a, ["children", "icon", "direction", "className"]);
    const [active, setActive] = useState(false);
    const showTooltip = () => {
        setActive(true);
    };
    const hideTooltip = () => {
        setActive(false);
    };
    return (_jsxs(BaseTooltip, Object.assign({ onMouseEnter: showTooltip, onMouseLeave: hideTooltip }, delegated, { children: [_jsx(IconWrapper, { children: icon !== null && icon !== void 0 ? icon : (_jsx(Icon, { "data-testid": "tooltip-icon", name: IconName.QUESTIONMARK, size: IconSize.SIZE20 }, void 0)) }, void 0), active ? (_jsx(BaseTooltipContent, Object.assign({ className: className, "data-testid": "tooltip-content", direction: direction }, { children: _jsx(BaseTooltipWrapper, { children: children }, void 0) }), void 0)) : null] }), void 0));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map